import type { DateRange } from "react-day-picker";
import { isValidDate } from "./isValidDate";
import { isWithinBounds } from "./isWithinBounds";

function clampToBounds(date: Date, startMonth?: Date, endMonth?: Date): Date {
  if (isValidDate(startMonth) && date.getTime() < startMonth.getTime()) {
    return startMonth;
  }
  if (isValidDate(endMonth) && date.getTime() > endMonth.getTime()) {
    return endMonth;
  }
  return date;
}

export function resolveDefaultMonth(
  defaultMonth: Date | undefined,
  selected: DateRange | undefined,
  startMonth?: Date,
  endMonth?: Date,
): Date {
  const now = new Date();
  const bounds = { min: startMonth, max: endMonth };
  const from = selected?.from;
  const to = selected?.to;
  const selectedAnchor = isValidDate(from)
    ? from
    : isValidDate(to)
      ? to
      : undefined;
  const rangeStart = isValidDate(startMonth) ? startMonth : selectedAnchor;

  if (isValidDate(defaultMonth)) {
    if (isWithinBounds(defaultMonth, bounds)) {
      return defaultMonth;
    }
    if (rangeStart) {
      return clampToBounds(rangeStart, startMonth, endMonth);
    }
    return clampToBounds(defaultMonth, startMonth, endMonth);
  }

  if (isValidDate(from) && isValidDate(to)) {
    const ordered =
      from.getTime() <= to.getTime()
        ? { min: from, max: to }
        : { min: to, max: from };
    if (isWithinBounds(now, ordered)) {
      return clampToBounds(now, startMonth, endMonth);
    }
    return clampToBounds(from, startMonth, endMonth);
  }

  if (isWithinBounds(now, bounds)) {
    return now;
  }
  if (rangeStart) {
    return clampToBounds(rangeStart, startMonth, endMonth);
  }
  return clampToBounds(now, startMonth, endMonth);
}
